import { STAMMDATEN_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { useHasPermission } from '@Contexts/appContext';
import { type ApiContainerType } from '@Model';
import {
    FrameFallback,
    type IFrameEditShellProps,
    useEditFrame,
    useFrameEditBaseNavigation,
} from '@synqo/frontend-component-library';
import { useMemo } from 'react';
import { useParams } from 'react-router';
import { ContainerTypeFrameBody } from './ContainerType/ContainerTypeFrameBody';

// @ai-generated 2026-10-21T09:24:28+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)

export function FrameEditContainerType(props: IFrameEditShellProps<ApiContainerType>) {
    const { itemId } = useParams();
    const primaryKey = props.primaryKey ?? itemId ?? '';

    return (
        <ContainerTypeEditFrame
            key={primaryKey}
            {...props}
            primaryKey={primaryKey}
            embedded={props.embedded || props.primaryKey !== undefined}
        />
    );
}

// @ai-generated 2026-10-21T10:02:26+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)

function ContainerTypeEditFrame(props: IFrameEditShellProps<ApiContainerType> & { primaryKey: string }) {
    const hasPermission = useHasPermission();

    const frameEditBaseNavigationEvents = useFrameEditBaseNavigation();

    const events = useMemo(
        () => ({
            ...frameEditBaseNavigationEvents,
            ...props.events,
        }),
        [frameEditBaseNavigationEvents, props.events],
    );

    const frame = useEditFrame<ApiContainerType>({
        apiResourcePath: `${STAMMDATEN_API}/container_types`,
        primaryKey: props.primaryKey,
        embedded: props.embedded,
        events,
        canEdit: props.canEdit !== false && hasPermission(Permission.StammdatenContainerTypeUpdate),
        canCreate: props.canCreate !== false && hasPermission(Permission.StammdatenContainerTypeCreate),
        canDelete: props.canDelete !== false && hasPermission(Permission.StammdatenContainerTypeDelete),
    });

    if (frame.status !== 'ready') {
        return <FrameFallback frame={frame} />;
    }

    return <ContainerTypeFrameBody key={frame.recordId} frame={frame} />;
}
